import { streamGroq, GroqMissingKeyError } from './groq-client';

export async function aiSummarize(transcriptText: string, onStream: (chunk: string) => void): Promise<void> {
  const system = `You are a meeting-notes specialist. Given this transcript, produce: 1) 3-sentence summary, 2) Decisions made, 3) Action items with owners (if mentioned), 4) Open questions. Markdown.`;
  try {
    await streamGroq({ messages: [{ role: 'system', content: system }, { role: 'user', content: transcriptText.slice(0, 12000) }], temperature: 0.3, onStream });
  } catch (err) {
    if (err instanceof GroqMissingKeyError) { onStream('\n\n⚠️ No Groq API key set. Click the Settings gear ⚙.'); return; }
    onStream(`\n\n⚠️ ${err instanceof Error ? err.message : 'Groq error'}`);
  }
}
